export const environment = {
  production: false,
  apiBaseUrl: 'https://6rpdi4qjbfc46rcl3l4kfp7pcu0qilhf.lambda-url.eu-central-1.on.aws/',
  // SECURITY: sostituire con una stringa casuale sicura — stessa chiave in dev e prod
  aesKey: '1XRm:3X>kl;C\]24D4fn%7M*rWbjh~',
  // Cloudflare Turnstile — site key is PUBLIC by design (like reCAPTCHA siteKey).
  // Only the secret key stays backend-side (TURNSTILE_SECRET_KEY in ../amajor.oca.node/.env).
  // TODO: sostituire con il vero site key dalla dashboard Cloudflare prima del deploy.
  // '1x00000000000000000000AA' = Cloudflare test key (always passes, dev only).
  turnstileSiteKey: '0x4AAAAAAC20NCY5Y7kKcM809h8XgUcFvIE'
};



